import { arrayMove } from '@dnd-kit/sortable'
import { produce } from 'immer'
import { v4 as uuid } from 'uuid'
import { immer } from 'zustand/middleware/immer'
import { createWithEqualityFn } from 'zustand/traditional'

export const useFormPlaygroundStore = createWithEqualityFn(
  immer((set) => ({
    formElements: [],
    setFormElements: (formElements) =>
      set(
        produce((draft) => {
          draft.formElements = formElements
        })
      ),
    addFormElement: (label, type) =>
      set(
        produce((draft) => {
          draft.formElements.push({
            id: uuid(),
            label,
            type,
            required: false,
            options: ['checklist', 'multi-choice', 'dropdown', 'combobox'].includes(type)
              ? [
                  { label: 'Option 1', value: uuid() },
                  { label: 'Option 2', value: uuid() },
                ]
              : undefined,
          })
        })
      ),
    moveFormElement: (oldIndex, newIndex) =>
      set(
        produce((draft) => {
          draft.formElements = arrayMove(draft.formElements, oldIndex, newIndex)
        })
      ),
    updateLabel: (id, label) =>
      set(
        produce((draft) => {
          draft.formElements.forEach((el) => {
            if (el.id === id) {
              el.label = label
              return
            }
          })
        })
      ),
    toggleRequired: (id) =>
      set(
        produce((draft) => {
          draft.formElements.forEach((el) => {
            if (el.id === id) {
              el.required = !el.required
              return
            }
          })
        })
      ),
    addOption: (id) =>
      set(
        produce((draft) => {
          draft.formElements.forEach((el) => {
            if (el.id === id) {
              el.options?.push({
                label: 'Option ' + (el.options.length + 1),
                value: uuid(),
              })
              return
            }
          })
        })
      ),
    updateOption: (id, optionId, label) =>
      set(
        produce((draft) => {
          const formEl = draft.formElements.find((el) => el.id === id)
          formEl?.options?.forEach((option) => {
            if (option.value === optionId) {
              option.label = label
              return
            }
          })
        })
      ),
    deleteOption: (id, optionId) =>
      set(
        produce((draft) => {
          const formEl = draft.formElements.find((el) => el.id === id)
          if (formEl?.options) {
            formEl.options = formEl.options.filter((option) => option.value !== optionId)
          }
        })
      ),
    removeFormElement: (id) =>
      set(
        produce((draft) => {
          draft.formElements = draft.formElements.filter((el) => el.id !== id)
        })
      ),
    removeAllFormElements: () =>
      set(
        produce((draft) => {
          draft.formElements = []
        })
      ),
  })),
  Object.is
)
